<template>
    <div class="user-training-index" v-loading="loading">
        <TrainingBaseInfo :detail="classDetail"></TrainingBaseInfo>
        <div class="training-class-step-wrap">
            <Step :active="stepAcvive" :list="stepList"></Step>
            <div class="training-class-step-btns">
                <div v-for="(item, index) in stepList" :key="index" class="training-class-step-btn" @click="handleChangeStep(index+1)"></div>
            </div>
        </div>
        <div>
            <StepPage1 v-if="stepAcvive === 1" :formData="formData" :userList="userList" :trainTeachersId="formData.trainTeachersId" @saveStep="saveFirstStep"></StepPage1>
            <StepPage2 v-if="stepAcvive === 2" :formData="formData" :userList="userList" @saveStep="saveSecondStep"></StepPage2>
            <StepPage3 v-if="stepAcvive === 3" :formData="formData" @stepSave="saveThirdStep"></StepPage3>
            <StepPage4 v-if="stepAcvive === 4" :formData="formData"></StepPage4>
            <StepPage5 v-if="stepAcvive === 5" :formData="formData" @submitProject="trainClassDetail"></StepPage5>
        </div>
    </div>
</template>
<script>
import TrainingBaseInfo from './components/trainingBaseInfo.vue' // 基本信息
import Step from './components/step.vue' // 步骤条
import StepPage1 from './components/trainingStep1.vue' // 步骤1
import StepPage2 from './components/trainingStep2/trainingStep2.vue' // 步骤2
import StepPage3 from './components/trainingStep3.vue' // 步骤3
import StepPage4 from './components/trainingStep4.vue' // 步骤4
import StepPage5 from './components/trainingStep5.vue' // 步骤5


export default {
    name: 'TrainingClassPage',
    components: { TrainingBaseInfo, Step, StepPage1, StepPage2, StepPage3, StepPage4, StepPage5 },
    data() {
        return {
            loading: false,
            stepAcvive: 1,
            stepList: ['基本信息', '活动安排', '人员安排', '培训班管理', '培训班结项'],
            formData: {
                status: 7,
                trainActivitys: [], // 第二页活动
                trainStudents: [], // 第三页指定人员
                trainTeachers: [],
                trainTeachersId: [],
                trainWhitelists: [] // 第三页白名单
            },
            classDetail: {},
            userList: []
        }
    },
    activated() {
        this.stepAcvive = this.$route.query.step ? this.$route.query.step * 1 : 1
        this.initPage()
    },
    methods: {
        initPage() {
            this.trainClassDetail()
            this.getUserList()
        },
        trainClassDetail() {
            this.loading = true
            this.$api.user.train.trainClassDetail({
                id: this.$route.query.id
            }).then(res => {
                this.loading = false
                this.classDetail = res.data
                this.formData = res.data
                this.formData.trainTeachersId = []
                this.formData.delActivityIds = []
                if (res.data.teacherList) {
                    for (let item of res.data.teacherList) {
                        this.formData.trainTeachersId.push(item.teacherUserId)
                    }
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleChangeStep(index) {
            if (this.stepAcvive === index) {
                return
            }
            this.stepAcvive = index
        },
        saveFirstStep() {
            let _params = this.transSaveData()
            this.$api.user.train.trainClassUpdate(_params).then(res => {
                this.$message({ type: 'success', message: '保存成功' })
                this.trainClassDetail()
            })
        },
        saveSecondStep() {
            let _params = this.transSaveData()
            this.$api.user.train.trainClassUpdate(_params).then(res => {
                this.$message({ type: 'success', message: '保存成功' })
                this.trainClassDetail()
            })
        },
        saveThirdStep() {
            let _params = this.transSaveData()
            this.$api.user.train.trainClassUpdate(_params).then(res => {
                this.$message({ type: 'success', message: '保存成功' })
                this.trainClassDetail()
            })
        },
        transSaveData() {
            let _params = JSON.parse(JSON.stringify(this.formData))
            delete _params.teacherList
            delete _params.trainTeachersId
            _params.trainTeachers = []
            if (this.formData.trainTeachersId) {
                for (let item of this.formData.trainTeachersId) {
                    _params.trainTeachers.push({teacherUserId: item}) 
                }
            }
            return _params
        },
        // 老师
        getUserList() {
            this.$api.user.baseInfo.userList({formData: {teacher: 1}, pageData: {currentPage: 1, pageSize: 99999}}).then(res => {
                this.userList = res.data.list
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';

.user-training-index {
    margin: 0 0 .36rem;
    box-shadow: -10px 0px 16px 0px rgba(0, 0, 0, 0), 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: .04rem;
    overflow: hidden;
}
.training-class-step-wrap {
    position: relative;
    .training-class-step-btns {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 0.34rem 1.1rem 0.3rem;
        left: 0;
        top: 0;
    }
    .training-class-step-btn {
        position: absolute;
        top: .3rem;
        width: 1rem;
        height: .54rem;
        cursor: pointer;
        &:nth-child(2) {
            left: 3.28rem;
        }
        &:nth-child(3) {
            left: 5.48rem;
        }
        &:nth-child(4) {
            left: 7.78rem;
        }
        &:nth-child(5) {
            right: 1.1rem;
        }
    }
}
</style>
<style lang="scss">
@import '../../styles/variables.scss';


</style>